import IconBarMenuItem from './IconBarMenuItem';
export default IconBarMenuItem;
